export default "__VITE_ASSET__baa9cf54__"